$(document).ready(function () {
 
  var menuAbierto = false;
  $('.menu-movil').on('click', function () {
    $(this).toggleClass('close');
    if (!menuAbierto) {
      $('.menu-wrapper').toggleClass('close');
      setTimeout(function () {
        $('.menu-container').toggleClass('close');
      }, 350);
    } else {
      $('.menu-container').toggleClass('close');
      setTimeout(function () {
        $('.menu-wrapper').toggleClass('close');
      }, 250);
    }

    $('body').toggleClass('blocked');
    menuAbierto = !menuAbierto;
  });

  // Detecta si existe barra de info

  if ($('.info-bar').length === 0) {
    $('#cupon').addClass('no-bar');
  }

  // Enseña y oculta elementos del footer
  $('.toggle span').each(function () {
    $(this).click(function () {
      $(this).parent().next().slideToggle();
      $(this).toggleClass('open close');
    });
  });

  // La lupa en tablet, abra el buscador del menú
  $('#lupa-tablet').click(function () {
    $('#menu-toggle').click();
    $('#nav-search-movil').focus();
  });

  $('#search-icon').on('click', function () {
    $(this).toggleClass('animate');
    $('.search-bar input').toggleClass('active');
    if (window.matchMedia('(max-width: 1399px)').matches) {
      $('.phone-link').toggleClass('telefon-open');
    }
  });

  //Activa el boton del teléfono del nav
  $('#phone-icon').click(function () {
    if ($('.formPhone').hasClass('search-active')) {
      $('.formPhone')
        .removeClass('search-active')
        .addClass('search-close')
        .focus();
      $('.phone-link').hide();
    } else {
      $('.formBuscador')
        .removeClass('search-active')
        .addClass('search-close')
        .focus();
      $('#search-btn').hide();

      $('.formPhone')
        .removeClass('search-close')
        .addClass('search-active')
        .focus();
      $('.phone-link').show();
    }
  });

  // Activa el submenu del nav

  setTimeout(function () {
    $('.dropdown').css({ display: 'grid' });
  }, 0.1);

  // Forma marronera de mantener el cupon en su sitio

  if ($('.area-cupon').length > 0) {
    const altura = $('#d-main').height();
    $('.area-cupon').height(altura);
  }
  // Elimina parrafos vacios

  $('.ficha-curso-intro, .single-content').each(function () {
    $(this)
      .find('p')
      .each(function () {
        if ($(this).text().trim() === '' && !($(this).html().indexOf("img") > -1)) {
          $(this).remove();
        }
      });
    $(this)
      .find('td.diploma')
      .each(function () {
        $(this).remove();
      });
  });

  // Abrir buscador
  $('.search-btn').on('click', function () {
    var palabra = $('#nav-search').val();
    var palabraMovil = $('#nav-search-movil').val();
    if (
      (palabra != null && palabra != '') ||
      (palabraMovil != null && palabraMovil != '')
    ) {
      if (palabra != null && palabra != '') var palabraFinal = palabra;
      else var palabraFinal = palabraMovil;

      $('.container-modal-buscador').addClass('d-none').html('');

      jQuery.ajax({
        type: 'POST',
        async: true,
        url: rutajs + 'lib/ajax.php',
        data: 'fn=getCursosBuscador&palabra=' + palabraFinal,
        success: function (data) {
          var returnedData = JSON.parse(data);
          var numResultados = returnedData.length;
          var htmlResultados = '';
          if (numResultados == 0) {
            htmlResultados =
              '' +
              '<h5 class="modal-titulo">No se han encontrado resultados para <span>' +
              palabraFinal +
              '</span></h5>';
          } else {
            if (numResultados == 1) {
              htmlResultados =
                '' +
                '<h5 class="modal-titulo">Encontrado <span id="numero-resultado">' +
                numResultados +
                '</span> resultado para \'<span id="tag-resultado">' +
                palabraFinal +
                "</span>'</h5>";
            } else {
              htmlResultados =
                '' +
                '<h5 class="modal-titulo">Encontrados <span id="numero-resultado">' +
                numResultados +
                '</span> resultados para \'<span id="tag-resultado">' +
                palabraFinal +
                "</span>'</h5>";
            }
            htmlResultados += '' + '<ul class="lista-resultados">';

            $.each(returnedData, function (key, value) {
              htmlResultados +=
                '' +
                '<li><a id="" class="title-curso" href="' +
                rutaweb +
                value['sUrl'] +
                '" title="' +
                value['sNombre'] +
                '" alt="' +
                value['sNombre'] +
                '" >' +
                value['sNombre'] +
                '</a></li>';
            });

            htmlResultados += '</ul>';
          }
          $('.container-modal-buscador')
            .removeClass('d-none')
            .html(htmlResultados);
          $('.overlay-modal').show(20);
          $('#modal-buscador').addClass('active').removeClass('inactive');
          $('body, html').addClass('blocked');

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "search",
            customer_id: v_client_id,
            query: palabraFinal,
            resultados: numResultados,
            template: v_template,
            specialization: getTipoCurso(),
            category: v_page_category,
            subcategory: v_page_subcategory,
            course: v_page_name,
            modality: v_modality,
            academy: v_academy,
            search_bar_position: 'HEADER',
          });
        },
      });
    }
  });

  // Cerrar buscador
  $('#search-modal-close').on('click', function () {
    if ($('#modal-buscador').hasClass('active')) {
      $('#modal-buscador').addClass('inactive').removeClass('active');
      $('.overlay-modal').hide(20);
      $('body, html').removeClass('blocked');
    }
  });

  $('.formBuscador').submit(function (event) {
    event.preventDefault();
    $('.search-btn').click();
  });

  // Sustituye a javascript:void(0) - No SEO friendly

  $('.no-action').on('click', function (e) {
    e.preventDefault();
  });

  // Despliega las faqs
  $('.faq-single').each(function () {
    $(this).on('click', function () {
      $(this).toggleClass('faq-open');
      $(this).find('.faq-desc').slideToggle();
    });
  });

  $('#desplegar-cupon, #btnInfoGeneralCupon').on('click', function () {
    $('.cupon-main').removeClass('d-none').slideDown();
    $('#desplegar-cupon').addClass('d-none');
  });

  // Slider Video en ficha

  if ($('.slider-video-wrapper').length) {
    $('.slider-video').slick({
      ladyload: 'ondemand',
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          },
        },
        
      ],
    });

    // Slider Video Nav
    $('.slider-video-nav-prev').on('click', function() {
      $('.slider-video').slick('slickPrev');
    });

    $('.slider-video-nav-next').on('click', function() {
      $('.slider-video').slick('slickNext');
    });

      // Slider Modal Video

    $('.video-slide').each(function() {
      $(this).on('click', function() {
        const videoId = $(this).data('video');
        console.log( $(`.video-slider-modal[data-modal=${videoId}]`));
        $('.overlay-modal').show(450);
        setTimeout(function() {
          $(`.video-slider-modal[data-modal=${videoId}]`).fadeIn(500);
        },500)
      })
    });

    $('.video-modal-close').on('click',function() {
      $('.video-slider-modal').fadeOut(500);
      setTimeout(function() {
        $('.overlay-modal').hide(450);
      },500)
    });
  }

  $('#vermas-ab').click(function () {
    // mostramos los items de dos en dos usando la clase .oculto
    // la usamos, la borramos.
    // cuando ya no quedan mas, ocultamos el boton "ver mas"

    for (var i = 0; i < 2; i++) {
      $('.oculto:first').removeClass('d-none');
      $('.oculto:first').removeClass('oculto');
    }

    if ($('.oculto.d-none').length == 0) {
      $(this).addClass('d-none');
    }
  });

  $('#frmCupon').on('change keypress textInput input', function (){
    if (v_unica_start == 1)
      enviarEventoFormulario(2);
    v_unica_start = 2;
  });


});

function empty(mixed_var) {
  var undef, key, i, len;
  var emptyValues = [undef, null, false, 0, '', '0'];

  for (i = 0, len = emptyValues.length; i < len; i++) {
    if (mixed_var === emptyValues[i]) {
      return true;
    }
  }

  if (typeof mixed_var === 'object') {
    for (key in mixed_var) {
      return false;
    }
    return true;
  }

  return false;
}

function desplegarOpiniones() {
  var pagina = $('#paginaOpinion').val();
  var maxPagina = $('#maxPaginaOpinion').val();
  var nuevaPagina = parseInt(pagina) + parseInt(1);
  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  var htmlOpiniones = 'VER MÁS';
  $('#verMasOpiniones').html(htmlSpinner);
  jQuery.ajax({
    type: 'POST',
    url: rutajs + 'lib/ajax.php',
    data: 'fn=getMasOpiniones&_pag=' + nuevaPagina,
    success: function (data) {
      data = JSON.parse(data);
      if (data.aOpiniones != '') {
        $('.opiniones-main').append(data.aOpiniones);
        $('#verMasOpiniones').html(htmlOpiniones);
      }
    },
  });

  $('#paginaOpinion').val(nuevaPagina);
  if (nuevaPagina >= maxPagina) $('#verMasOpiniones').addClass('d-none');
}

function configurarCamposCupon(idpais) {
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoCodigoPostal = 'form_cupon_cupon_codigopostal';
  /***/ idCampoProvincia = 'provinciaid';
  /***/
  /* ********************************************* */



  if (idpais == 90 || idpais == 'ES') {
    getComboMD('provincia', 'true', idpais);

    $('#' + idCampoCodigoPostal).attr('required', true);
    $('#' + idCampoCodigoPostal + ', .' + idCampoCodigoPostal).show();
    $('#' + idCampoProvincia).attr('required', true);
    $('#' + idCampoProvincia + ', .' + idCampoProvincia).show();

    $('#requeridos_codigo_postal').val('codigopostal'); //Para que sea obligatorio el campo código postal                $('#provinciaid').attr('required',true);
    $('#requeridos_provincia').val('provinciaid'); //Para que sea obligatorio el campo provincia
  } else if (idpais == 249 || idpais == 61) {
    getComboMD('provincia', 'true', idpais);

    $('#' + idCampoProvincia).attr('required', true);
    $('#' + idCampoProvincia + ', .' + idCampoProvincia).show();
    $('#' + idCampoCodigoPostal).attr('required', false);
    $('#' + idCampoCodigoPostal).val(''); //Para que NO sea obligatorio el campo código postal
    $('#' + idCampoCodigoPostal + ', .' + idCampoCodigoPostal).hide();

    $('#requeridos_codigo_postal').val(''); //Para que NO sea obligatorio el campo código postal
    $('#requeridos_provincia').val('provinciaid'); //Para que sea obligatorio el campo provincia
  } else {

    $('#' + idCampoProvincia).attr('required', false);
    $('#' + idCampoProvincia + ', .' + idCampoProvincia).hide();
    $('#' + idCampoProvincia).val('');
    $('#' + idCampoCodigoPostal).attr('required', false);
    $('#' + idCampoCodigoPostal).val(''); //Para que NO sea obligatorio el campo código postal
    $('#' + idCampoCodigoPostal + ', .' + idCampoCodigoPostal).hide();

    $('#requeridos_codigo_postal').val(''); //Para que NO sea obligatorio el campo código postal
    $('#requeridos_provincia').val(''); //Para que NO sea obligatorio el campo provincia
  }
}

function configurarTelefono(idpais, codigoTelefonico, pattern) {
  /* CAMBIAR LOS IDS DE LOS CAMPOS SI ES NECESARIO */
  /***/
  /***/ idCampoTelefono = 'form_cupon_cupon_telefono';
  /***/
  /* ********************************************* */

  $('#prefTelf').find('.prefijo-box').html(codigoTelefonico);

  if (empty(pattern)) {
    $('#' + idCampoTelefono).removeAttr('pattern');
  } else {
    $('#' + idCampoTelefono).attr('pattern', pattern);
  }

  if (idpais == 90 || idpais == 'ES') {

    maxlengthTelefono = 9;
    minlengthTelefono = 9;

    $('#' + idCampoTelefono).attr('maxlength', maxlengthTelefono);
    $('#' + idCampoTelefono).attr('minlength', minlengthTelefono);
  } else {
    maxlengthTelefono = 25;
    const [min, max] = Array.from(pattern.matchAll(/\d+/g));

    $('#' + idCampoTelefono).attr('maxlength', max[0]);
    $('#' + idCampoTelefono).attr('minlength', min[0]);
  }

  $('#form_cupon_prefijo').val(codigoTelefonico);
}

function restringirCampoNumerico(idCampo) {
  $('#' + idCampo).on('input', function () {
    $(this).keyup(function (key) {
      if ($.isNumeric($(this).val()) === false) {
        $(this).val(
          $(this)
            .val()
            .replace(/[^0-9\.]/g, '')
        );
      }
    });
  });
}

function setForwardUrl(form_id, baseUrl, idEstudio, idPais) {
  idEstudio = idEstudio || null;
  idPais = idPais || 90;
  if (idEstudio == null) {
    idEstudio = $('#' + form_id + ' #form_cupon_idcurso').val();
  }
  telefono = $('#' + form_id + ' #form_cupon_cupon_telefono').val();
  transaction_id = $('#' + form_id + ' #form_cupon_cupon_transaction_id').val();
  adsid = $('#' + form_id + ' #form_cupon_cupon_adsid').val();

  if (compruebaTelefonoCaracteres(form_id, 'form_cupon_cupon_telefono'))
    return false;

  var htmlSpinner =
    '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';

  $('#btnInformacion').attr('disabled', true);
  $('#btnInformacion').html(htmlSpinner);

  if (baseUrl == null) {
    baseUrl = rutaweb + rutajs;
  }

  $('#' + form_id + ' #forward_url').val(
    baseUrl +
      'gracias?idCursoReal=' +
      idEstudio +
      '&telefono=' +
      telefono +
      '&pais=' +
      idPais +
      '&transaction_id=' +
      transaction_id +
      '&adsid=' +
      adsid
  );

  enviarEventoFormulario(0);
  enviarEventoFormulario(3);
  return true;
}

function chkPais(idpais) {
  $('#requeridos_observaciones').val(''); //Para que NO sea obligatorio el campo LADA por servidor (solo para méxico)
  configurarCamposCupon(idpais);

  if(!$("#prefTelf").hasClass("no-change")) {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + 'lib/ajax.php',
      data: 'fn=getCodigosPaises&idpais=' + idpais,
      success: function (data) {
        data = JSON.parse(data);
  
        configurarTelefono(idpais, data.sCodigoTelefonico, data.sTelefPattern);
      },
    });
  }
}

function chkPrefijo(sCodigoTelefonico, sCodPais, sTelefPattern, sTooltip) {
  if(!$("#prefTelf").hasClass("no-change"))
    $("#prefTelf").addClass("no-change")
  
  configurarTelefono(sCodPais, sCodigoTelefonico, sTelefPattern);
}

function goTo(id, errorForm = '') {
  $('html, body').animate(
    { scrollTop: $('#' + id).offset().top - '200' },
    'slow'
  );

  if (!empty(errorForm))
    enviarEventoFormulario(4);

}

function cargaCategorias() {
  var valorTipo = $('#tipoCuponGeneral').val();
  $('.datos-cupon').addClass('hidden');
  if (valorTipo != '') {
    $('#CategoriaCuponGeneral').html('');
    jQuery.ajax({
      type: 'POST',
      async: true,
      url: rutajs + 'lib/ajax.php',
      data: 'fn=getCategorias&valorTipo=' + valorTipo,
      success: function (data) {
        data = JSON.parse(data);
        if (data.aCategorias.length > 0) {
          var html = '<option value="">Selecciona una categoría</option>';
          $.each(data.aCategorias, function (index, value) {
            html +=
              '' +
              '<option value="' +
              value.idCategoria +
              '">' +
              value.sNombre +
              '</option>';
          });

          $('#CategoriaCuponGeneral').html(html);
          $('.caja-categoria').removeClass('hidden');

          if (catCupon != '' && catCupon != undefined) {
            $('#CategoriaCuponGeneral option[value=' + catCupon + ']').prop(
              'selected',
              true
            );
            $('#CategoriaCuponGeneral').change();
          }
        }
      },
    });
  } else {
    $('.caja-categoria').addClass('hidden');
  }
}
function cargaCuponGeneral() {
  var valorCategoria = $('#CategoriaCuponGeneral').val();
  var valorTipo = $('#tipoCuponGeneral').val();
  if (valorCategoria != '' && valorTipo != '') {
    mostrarOcultarSpinner(true, '.form-cupon-general');
    var txtTipo = '';
    if (valorTipo == 1) {
      txtTipo = 'la oposición';
    } else if (valorTipo == 2) {
      txtTipo = 'el curso';
    } else if (valorTipo == 3) {
      txtTipo = 'la FP';
    }

    $('#form_cupon_idcurso').html('');
    jQuery.ajax({
      type: 'POST',
      async: true,
      url: rutajs + 'lib/ajax.php',
      data:
        'fn=getCursosGrupo&valorCategoria=' +
        valorCategoria +
        '&valorTipo=' +
        valorTipo,
      success: function (data) {
        data = JSON.parse(data);
        if (data.aCursos.length > 0) {
          var html =
            '<option value="">-- Quiero información sobre ' +
            txtTipo +
            ': --</option>';
          var curso1 = data.aCursos[0];
          var idGrupo = curso1.idGrupo;
          var nGrupo = '';
          if (curso1.sGrupo != undefined) nGrupo = curso1.sGrupo;
          else nGrupo = curso1.categoriaNombre;

          html += '<optgroup label="' + nGrupo + '">';

          $.each(data.aCursos, function (index, value) {
            if (value.idGrupo != idGrupo) {
              if (value.sGrupo != undefined) nGrupo = value.sGrupo;
              else nGrupo = value.categoriaNombre;

              html += '</optgroup><optgroup label="' + nGrupo + '">';
              idGrupo = value.idGrupo;
            }
            var selected = '';
            if (value.idCursoReal == curCupon) {
              selected = ' selected="selected"';
            }
            html +=
              '' +
              '<option value="' +
              value.idCursoReal +
              '"' +
              selected +
              '>' +
              value.sNombre +
              '</option>';
          });
          html += '</optgroup>';
          $('.datos-cupon #form_cupon_idcurso').html(html);

          if (valorTipo == 1) {
            getComboMD('nacionalidad', 'true', '', '.datos-cupon ');
            getComboMD('estudio', 'true', '', '.datos-cupon ');

            $('.datos-cupon #requeridos_pais').attr('name', '');
            $('.datos-cupon #paisid').removeAttr('required');
            $('.datos-cupon #cont-pais').addClass('hidden');

            $('.datos-cupon #requeridos_nacionalidad').attr(
              'name',
              'requeridos[]'
            );
            $('.datos-cupon #cont-nacionalidad').removeClass('hidden');
            $('.datos-cupon #nacionalidad').attr('required', true);

            $('.datos-cupon #requeridos_edad').attr('name', 'requeridos[]');
            $('.datos-cupon #cont-edad').removeClass('hidden');
            $('.datos-cupon #edad').attr('required', true);

            $('.datos-cupon #requeridos_estudiosid').attr(
              'name',
              'requeridos[]'
            );
            $('.datos-cupon #cont-estudiosid').removeClass('hidden');
            $('.datos-cupon #estudiosid').attr('required', true);

            $('#prefTelf').find('.prefijo-box').html('0034');
            $('#prefTelf .prefijo-dropdown').attr('disabled', true);
            $('#form_cupon_prefijo').val('0034');

          } else if (valorTipo == 2) {
            getComboMD('pais', 'true', '', '.datos-cupon ');

            $('.datos-cupon #requeridos_nacionalidad').attr('name', '');
            $('.datos-cupon #nacionalidad').removeAttr('required');
            $('.datos-cupon #cont-nacionalidad').addClass('hidden');

            $('.datos-cupon #requeridos_edad').attr('name', '');
            $('.datos-cupon #edad').removeAttr('required');
            $('.datos-cupon #cont-edad').addClass('hidden');

            $('.datos-cupon #requeridos_pais').attr('name', 'requeridos[]');
            $('.datos-cupon #paisid').attr('required', true);
            $('.datos-cupon #cont-pais').removeClass('hidden');

            $('.datos-cupon #requeridos_estudiosid').attr('name', '');
            $('.datos-cupon #estudiosid').removeAttr('required');
            $('.datos-cupon #cont-estudiosid').addClass('hidden');

            $('#prefTelf .prefijo-dropdown').attr('disabled', false);
          } else {
            getComboMD('pais', 'true', '', '.datos-cupon ');
            getComboMD('estudio', 'true', '', '.datos-cupon ');

            $('.datos-cupon #requeridos_nacionalidad').attr('name', '');
            $('.datos-cupon #nacionalidad').removeAttr('required');
            $('.datos-cupon #cont-nacionalidad').addClass('hidden');

            $('.datos-cupon #requeridos_edad').attr('name', '');
            $('.datos-cupon #edad').removeAttr('required');
            $('.datos-cupon #cont-edad').addClass('hidden');

            $('.datos-cupon #requeridos_pais').attr('name', 'requeridos[]');
            $('.datos-cupon #paisid').attr('required', true);
            $('.datos-cupon #cont-pais').removeClass('hidden');

            $('.datos-cupon #requeridos_estudiosid').attr(
              'name',
              'requeridos[]'
            );
            $('.datos-cupon #cont-estudiosid').removeClass('hidden');
            $('.datos-cupon #estudiosid').attr('required', true);
          }

          $('.datos-cupon').removeClass('hidden');
        }

        if (typeof loadRecaptchaLibrary === 'function') loadRecaptchaLibrary();
      },
    }).done(function(){
      mostrarOcultarSpinner(false, '.form-cupon-general');
    });
  } else {
    $('.datos-cupon').addClass('hidden');
  }
}

function getComboMD(tipo, required, padre, clase) {
  clase = clase !== '' ? clase : 'form-control';

  jQuery.ajax({
    type: 'POST',
    async: false,
    url: rutajs + 'lib/ajax.php',
    data:
      'fn=getComboMD&tipo=' +
      tipo +
      '&required=' +
      required +
      '&padre=' +
      padre +
      '&class=' +
      clase,
    success: function (data) {
      $('#cont-' + tipo).html(data);
      if (tipo == 'pais') {
        jQuery('#cont-' + tipo + ' select').attr(
          'onchange',
          'chkPais($(this).val())'
        );
        jQuery(
          '#cont-' + tipo + ' select option[value="' + idpais + '"]:first'
        ).prop('selected', true);
        configurarCamposCupon(idpais);
        configurarTelefono(idpais, prefijotelefonico, patterntelefonico);
      
      }
    },
  });
}

/**
 * Para responder a un comentario
 */
function responder(idComentario, responde) {
  $('#idPadre').val(idComentario);
  $('#infocomentario').html('Está respondiendo a ' + responde + ':');
}

function validarComentario() {
  var error = '';
  if (document.getElementById('nombre').value == '') {
    error = error + ' Falta el nombre.\n';
    document.getElementById('nombre').style.border = '1px solid #ff0000';
  } else {
    document.getElementById('nombre').style.border = '1px solid #d4d4d4';
  }

  if (document.getElementById('email').value == '') {
    error = error + ' Falta el email o mal escrito.\n';
    document.getElementById('email').style.border = '1px solid #ff0000';
  } else {
    document.getElementById('email').style.border = '1px solid #d4d4d4';
  }

  if (document.getElementById('mensaje').value == '') {
    error = error + ' Falta el mensaje.\n';
    document.getElementById('mensaje').style.border = '1px solid #ff0000';
  } else {
    document.getElementById('mensaje').style.border = '1px solid #d4d4d4';
  }
  /*
    if (document.getElementById('secure').value == '' ){
        error = error + ' Falta el campo de seguridad.\n';
        document.getElementById('secure').style.border='1px solid #ff0000';
    }else{
        document.getElementById('secure').style.border='1px solid #d4d4d4';
    }
*/

  if (error != '') {
    alert('Faltan campos, revisa el formulario:\n' + error);
    return false;
  } else {
    return true;
  }
}

function scrollCupon(idForm) {
  var heightHeader = $('nav').outerHeight() * 2;

  $('html, body').animate(
    {
      scrollTop: $('#' + idForm).offset().top - heightHeader,
    },
    2000
  );

  $('#' + idForm + " input[name='nombre']").focus();
  if ($(window).width() > 991) {
    $('#' + idForm)
      .find("button[type='submit']")
      .click();
    $('#' + idForm).addClass('formulario-activo');
    setTimeout(function () {
      $('#' + idForm).removeClass('formulario-activo');
    }, 2500);
  }
}

function compruebaTelefonoCaracteres(form_id, telefono) {
  var nTelefono = $('#' + form_id + ' #' + telefono).val();
  var inputTelefono = document.getElementById(telefono);

  let n = nTelefono.length;
  for (let i = 1; i < n; i++) if (nTelefono[i] != nTelefono[0]) return false;

  $('#' + form_id + ' #' + telefono).val('');
  inputTelefono.reportValidity();

  return true;
}

function enviarEvento() {
  var valorCategoria = $('#CategoriaCuponGeneral option:selected').html();
  var valorCurso = $('#form_cupon_idcurso option:selected').html();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'form_send',
    step: '1',
    formacion: 'curso',
    categoria: valorCategoria, // Aquí la categoría de la elección anterior.
    curso: valorCurso, // Aquí el curso que ha elegido en función de la categoria.
  });

  enviarEventoFormulario(2);
}

function enviarEventoFormulario(tipoEvento = 0) {
  var valorTipo = getTipoCurso();
  var v_form_subcategory = 'undefined';

  var valorTipoCupon = $('#tipo_cupon').val();
  if (typeof valorTipoCupon === 'undefined') {
    var valorTipoCupon = 'PDP';
  }

  var valorCategoria = v_form_category = $('#CategoriaCuponGeneral option:selected').html(); // Este valor está en el cupón del modal
  if (typeof valorCategoria === 'undefined') {
    // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCategoria = v_form_category = $('#form_cupon_categoria').val();
    if (typeof valorCategoria === 'undefined') {
      // Si estoy en un listado lo cojo del select del curso
      var valorCategoria = v_form_category = $('#form_cupon_idcurso option:selected').attr(
        'data-categoria'
      );
    }
  }
  var valorCurso = $('#form_cupon_idcurso option:selected').html();
  if (typeof valorCurso === 'undefined') {
    // Si no estoy en el modal, cojo el valor del cupón de la ficha
    var valorCurso = $('#form_cupon_nombre_curso').val();
  }
  var valorPais = $('#paisid option:selected').html();
  if (typeof valorPais === 'undefined') {
    var valorPais = $('#form_cupon_cupon_paisid option:selected').html();
  }
  if (valorPais == '-- Pais --') valorPais = '';
  var valorProvincia = $('#provinciaid option:selected').html();
  if (valorProvincia == '-- Provincia --' || valorProvincia == '-- Estado --')
    valorProvincia = '';
  
  var valorNacionalidad = $('#nacionalidad option:selected').html();
  if (valorNacionalidad == '-- Nacionalidad --') valorNacionalidad = '';
  var valorEdad = $('#edad option:selected').html();
  if (valorEdad == '-- Edad --') valorEdad = '';
  var valorEstudios = $('#estudiosid option:selected').html();
  if (valorEstudios == '-- Nivel de estudios --') valorEstudios = '';

  if (valorEstudios == '-- Nivel Estudios --') valorEstudios = '';
  // Recogemos valor de Nombre, Email, Teléfono y CP y los hasheamos
  var valorNombre = $('#form_cupon_cupon_nombre').val();
  var valorCP = $('#form_cupon_cupon_codigopostal').val();
  var valorEmail = $('#form_cupon_cupon_email').val();
  var valorTelefono = $('#form_cupon_cupon_telefono').val();
  if(empty(valorEmail)) {
    valorEmail = 'undefined';
    valorHashEmail = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + "lib/ajax.php",
      data : 'fn=encryptEvento&email='+valorEmail,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashEmail = data.email;
      },
      error: function() {
        valorHashEmail = 'undefined';
      }
    });
  }
  if(empty(valorTelefono)) {
    valorTelefono = 'undefined';
    valorHashTelefono = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + "lib/ajax.php",
      data : 'fn=encryptEvento&email='+valorTelefono,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashTelefono = data.email;
      },
      error: function() {
        valorHashTelefono = 'undefined';
      }
    });
  }

  if(empty(valorNombre)) {
    valorNombre = 'undefined';
    valorHashNombre = 'undefined';
  } else {
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + "lib/ajax.php",
      data : 'fn=quitaMayusculasYacentos&cadena='+valorNombre,
      success: function(data) {     
        valorNombreSinAcentos = data;
      },
      error: function() {
        valorNombreSinAcentos = 'undefined';
      }
    });

    if(valorNombreSinAcentos != 'undefined' && valorNombreSinAcentos.trim().length !== 0) {
      jQuery.ajax({
        type: 'POST',
        async: false,
        url: rutajs + "lib/ajax.php",
        data : 'fn=encryptEvento&email='+valorNombreSinAcentos,
        success: function(data) {
          data = JSON.parse(data);
          
          valorHashNombre = data.email;
        },
        error: function() {
          valorHashNombre = 'undefined';
        }
      });
    } else {
      valorHashNombre = 'undefined';
    }

  }

  if(empty(valorCP)) {
    valorCP = 'undefined';
    valorHashCP = 'undefined';
  } else {

    // solo le quitamos espacios y guiones al valor hasheado
    var valorCP_2 = valorCP;

    if (valorCP_2.includes(" ")) {
      valorCP_2 = valorCP_2.replace(/\s+/g, ""); // Elimina todos los espacios
    }
    if (valorCP_2.includes("-")) {
      valorCP_2 = valorCP_2.replace(/-/g, ""); // Elimina todos los guiones
    }
    jQuery.ajax({
      type: 'POST',
      async: false,
      url: rutajs + "lib/ajax.php",
      data : 'fn=encryptEvento&email='+valorCP_2,
      success: function(data) {
        data = JSON.parse(data);
        
        valorHashCP = data.email;
      },
      error: function() {
        valorHashCP = 'undefined';
      }
    });
  }
  
  var valorTransaction = $('#transactionIdWeb').val();


  if (tipoEvento == 0){
    window.dataLayer = window.dataLayer|| [];
    window.dataLayer.push({
    'event': 'form_send',
    'step': '2',
    'formacion': valorTipo, // Aquí queremos saber qué ha elegido CURSO | OPOSICIONES | FP
    'categoria': valorCategoria, // Aquí la categoría de la elección anterior. 
    'curso': valorCurso, // Aquí el curso que ha elegido en función de la categoria.
    'pais': valorPais, // Queremos saber de qué país es.
    'provincia': valorProvincia, // Queremos saber de qué provincia es.
    'cp': valorCP, // Queremos saber el código postal.
    'nacionalidad': valorNacionalidad, // Queremos saber de qué nacionalidad es.
    'edad': valorEdad, // Queremos saber la edad escogida. 
    'nivel_estudios': valorEstudios // Queremos el nivel de estudios que ha indicado 
    });
  }else if (tipoEvento == 1){ // view_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_form",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
    });
    
  }else if (tipoEvento == 2){ // form_start
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "form_start",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory : v_form_subcategory,
      form_course: valorCurso,
      form_modality: 'Semipresencial',
    });
    
  }else if (tipoEvento == 3){ // generate_lead
    var valorCursoId = $('#form_cupon_idcurso_real').val();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "generate_lead",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory : v_form_subcategory,
      form_course: valorCurso,
      edu_pid : valorCursoId,
      form_modality: 'Semipresencial',
      transaction_id: valorTransaction,
      email: valorHashEmail,
      phone: valorHashTelefono,
      postal: valorCP,
      postal_hash: valorHashCP,
      nombre: valorHashNombre,
      age: valorEdad,
      education: valorEstudios,
      province: valorProvincia,
      nationality: valorNacionalidad

    });
    
  }else if (tipoEvento == 4){ // error_form
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "error_form",
      client_id: v_client_id,
      specialization: valorTipo,
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      form_type: valorTipoCupon,
      form_specialization: valorTipo,
      form_category: v_form_category,
      form_subcategory : v_form_subcategory,
      form_course: valorCurso,
      form_modality: 'Semipresencial',
      transaction_id: valorTransaction,
      email: valorHashEmail,
      phone: valorHashTelefono,
      postal: valorCP,
      age: valorEdad,
      education: valorEstudios,
      province: valorProvincia,
      nationality: valorNacionalidad,
      error_field: errorForm
    });
    
  }

}

function enviarEventoViewForm(){
  enviarEventoFormulario(1);
}

function contieneClasesEnArray(clases){
  var contiene = false;

  if(!empty(clases)) {
    var aClases = clases.split(' ');

    $.each(aClases, function (key, value) {
      if(jQuery.inArray(value, aClasesMakingScience) != -1)
        contiene = true;
    });
  }
  
  return contiene;
}

$(document).on('click', '.cta_menu_header',  function(e){
  if(!empty($(this).parent().parent().parent().parent().prev('.cta_menu_header').text().trim())) {
    var v_menu_category = $(this).parent().parent().parent().parent().prev('.cta_menu_header').text().trim();
    var v_menu_subcategory_1 = $(this).parent().parent().prev('.cta_menu_header').text().trim();
    var v_menu_subcategory_2 = $(this).text().trim();
  } else if(!empty($(this).parent().parent().prev('.cta_menu_header').text().trim())) {
    var v_menu_category = $(this).parent().parent().prev('.cta_menu_header').text().trim();
    var v_menu_subcategory_1 = $(this).text().trim();
    var v_menu_subcategory_2 = '';
  } else {
    var v_menu_category = $(this).text().trim();
    var v_menu_subcategory_1 = '';
    var v_menu_subcategory_2 = '';
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_header",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    menu_category: v_menu_category.toUpperCase(),
    menu_subcategory_1: v_menu_subcategory_1.toUpperCase(),
    menu_subcategory_2: v_menu_subcategory_2.toUpperCase()
  });
});

$(document).on('click', '.cta_menu_footer',  function(e){
  if(!empty($(this).parent().prev('.cta_menu_footer').attr('data-texto'))) {
    var v_menu_category = $(this).parent().prev('.cta_menu_footer').attr('data-texto');
    var v_menu_subcategory_1 = $(this).text().trim();
  } else if(!empty($(this).parent().parent().prev('.cta_menu_footer').text().trim())) {
    var v_menu_category = $(this).parent().parent().prev('.cta_menu_footer').text().trim();
    var v_menu_subcategory_1 = $(this).text().trim();
  } else {
    var v_menu_category = $(this).text().trim();
    var v_menu_subcategory_1 = '';
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_menu_footer",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    menu_category: v_menu_category.toUpperCase(),
    menu_subcategory_1: v_menu_subcategory_1.toUpperCase()
  });
});

$(document).on('click', 'a, button',  function(e){
  if(!contieneClasesEnArray($(this).attr('class'))) {

    var v_cta_copy = '';

    if(!empty($(this).text().trim()))
      v_cta_copy = $(this).text().trim();
    else if(!empty($(this).attr('title')))
      v_cta_copy = $(this).attr('title');
    else if(!empty($(this).attr('alt')))
      v_cta_copy = $(this).attr('alt');
    
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "select_content",
      customer_id: v_client_id,
      template: v_template,
      specialization: getTipoCurso(),
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      cta_name: "GENERIC", 
      cta_copy: v_cta_copy.toUpperCase(), 
    });
  }
});

$(document).on('click', '.carousel',  function(e){
  var v_carousel_name = $(this).parent().attr('data-name');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "carousel",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    carousel_name: v_carousel_name.toUpperCase(), 
  });
});

$(document).on('click', '.ctc',  function(e){
  var v_ctc_position = $(this).attr('data-position');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "ctc",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    ctc_position: v_ctc_position.toUpperCase(), 
  });
});

$(document).on('click', '.cta_cmb',  function(e){
  var v_cta_copy = $(this).text().trim();

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_cmb",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    cta_name: 'CMB',
    cta_copy: v_cta_copy.toUpperCase(),
  });
});

$(document).on('click', '.cta_mapa',  function(e){
  var v_map_icon = $(this).attr('data-icon');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "cta_mapa",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    map_icon: v_map_icon.toUpperCase(),
  });
});

$(document).on('click', '.share',  function(e){
  var v_share_position = $(this).attr('data-position');
  var v_platform = $(this).attr('data-platform');

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "share",
    customer_id: v_client_id,
    template: v_template,
    specialization: getTipoCurso(),
    category: v_page_category,
    subcategory: v_page_subcategory,
    course: v_page_name,
    modality: v_modality,
    academy: v_academy,
    share_position: v_share_position.toUpperCase(),
    platform: v_platform.toUpperCase(),
  });
});

function enviarEventoScrollPage(v_scroll_percentage) {
  var porcentajeActual = $('footer').attr('data-porcentaje');
  var sendEvent = false;

  if(v_scroll_percentage >= 90 && porcentajeActual < 90) {
    sendEvent = true;
    v_scroll_percentage = 90;
  } else if(v_scroll_percentage >= 75 && porcentajeActual < 75) {
    sendEvent = true;
    v_scroll_percentage = 75;
  } else if(v_scroll_percentage >= 50 && porcentajeActual < 50) {
    sendEvent = true;
    v_scroll_percentage = 50;
  } else if(v_scroll_percentage >= 25 && porcentajeActual < 25) {
    sendEvent = true;
    v_scroll_percentage = 25;
  }

  if(sendEvent) {
    $('footer').attr('data-porcentaje', v_scroll_percentage);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "scroll_custom",
      customer_id: v_client_id,
      template: v_template,
      specialization: getTipoCurso(),
      category: v_page_category,
      subcategory: v_page_subcategory,
      course: v_page_name,
      modality: v_modality,
      academy: v_academy,
      scroll_percentage: v_scroll_percentage,
    });
  }
}

function scrollPage() {
  scroll = $(window).scrollTop();
  heightFooter = $('footer').outerHeight();
  totalPage = $('footer').offset().top;

  enviarEventoScrollPage((scroll * 100) / (totalPage - heightFooter));
}

$(window).scroll(function (event) {
  scrollPage();
});

$(window).resize(function (event) {
  scrollPage();
});

function getTipoCurso() {
  var valorTipo = $('#form_cupon_tipo_curso').val();

  if (typeof valorTipo === 'undefined')
    var valorTipo = '';

  return valorTipo;
}

function mostrarOcultarSpinner(mostrar, elementoContenedor) {
  var htmlSpinner =
      '<div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
  var spinnerContenedor = "<div class='spinner-contenedor'></div>";

  if (mostrar) {
      $(spinnerContenedor).appendTo(elementoContenedor);
      $('.spinner-contenedor').html(htmlSpinner);
  } else {
    
      $('.spinner-contenedor').remove();
  }
}

function cambiarTab(event, tabNumber) {
  event.preventDefault();

  // Remover clase active de todos los tabs y contenidos
  $('.tab-contenido').removeClass('active');
  $('.tabs-wrapper ul li').removeClass('active');

  // Activar el tab y contenido seleccionado
  $('#tab-delegacion-' + tabNumber).addClass('active');
  $('.tab-active-delegacion-' + tabNumber).addClass('active');
}
